module.exports = __webpack_public_path__ + "static/media/certificate.5324b3a7.jpeg";